import DataLayout from "components/ui/DataLayout";
import React from "react";

const ViewCustomer = () => {
  const tableHead = [
    {
      title: "name",
    },
    {
      title: "email",
    },
    {
      title: "message",
    },
    {
      title: "Status",
    },
  ];

  const tableBody = [
    {
      name: "name",
      status:'not responded',
      email: "kisanmahat2@gmail.com",
      message:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    },
    {
      name: "name",
      status:'not responded',
      email: "kisanmahat2@gmail.com",
      message:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    },
    {
      name: "name",
      status:'not responded',
      email: "kisanmahat2@gmail.com",
      message:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    },
  ];
  return (
    <div>
      <DataLayout
      title="View Mesasges"
      showFilter={true}
      showEdit={false}
      showAdd={true}
      showViewAll={false}
      addItemLink={'/contact/add'}
    ></DataLayout>
 
        <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
          <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
            <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
              <tr>
                <th scope="col" className="p-4">
                  <div className="flex items-center">
                    <input
                      id="checkbox-all-search"
                      type="checkbox"
                      className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 dark:focus:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                    />
                    <label for="checkbox-all-search" className="sr-only">
                      checkbox
                    </label>
                  </div>
                </th>
                {tableHead.map((val, i) => {
                  return (
                    <th key={i} scope="col" className="px-6 py-3">
                      {val.title}
                    </th>
                  );
                })}
              </tr>
            </thead>
            <tbody>
              {tableBody.map((val, i) => {
                return (
                  <tr key={i}  className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600">
                    <td className="w-4 p-4">
                      <div className="flex items-center">
                        <input
                          id="checkbox-table-search-1"
                          type="checkbox"
                          className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 dark:focus:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                        />
                        <label
                          for="checkbox-table-search-1"
                          className="sr-only"
                        >
                          checkbox
                        </label>
                      </div>
                    </td>
                    <th
                      scope="row"
                      className="px-6 capitalize py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white"
                    >
                      {val.name}
                    </th>
                    <td className="px-6 py-4 ">{val.email}</td>
                    <td className="px-6 py-4 text-justify">{val.message}</td>
                    <td className="px-6 py-4 text-justify capitalize">{val.status}</td>

                    <td className="flex items-center px-6 py-4 space-x-3">
                      <div
                        className="font-medium text-blue-600 dark:text-blue-500 hover:underline"
                      >
                        Edit
                      </div>
                      <div
                        className="font-medium text-red-600 dark:text-red-500 hover:underline"
                      >
                        Remove
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

       
    </div>
  );
};

export default ViewCustomer;
